"use client";

import { Box, useToken } from "@chakra-ui/react";
import { useLandingCursor } from "../../_hooks/useLandingCursor";

export function LandingCursor() {
  const ref = useLandingCursor(true);
  const [primary] = useToken("colors", ["primary.500"]);

  return (
    <Box
      ref={ref}
      className="landing-cursor-dot"
      display={{ base: "none", md: "block" }}
      bg={primary}
      aria-hidden
    />
  );
}
